
import React from "react";
import { useEffect } from "react";
import { Grid, Stack, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import HistoryTracker from "./HistoryTracker";
import TopSection from "../../../Components/Common/Top/TopSection";
import { setActiveDataElement } from "../../../redux/userSlice";

const History = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Bottler Concentrate Forecast"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              labelList={[
                { title: "Home", path: "/dashboard" },
                { title: "History" },
              ]}
              title = "Concentrate Forecast Upload History"
            />
            <div class = "container">
              <HistoryTracker></HistoryTracker>
            </div>

          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default History;

